import { TwoColumnLayout } from 'layouts';
import type { PublicEventContentObject } from 'models';
import { EventDetailCountdown } from '../../components';
import { PublicProgramEventHeader } from '../../public-program-event-header';
import { ProgramEventJoinStatusAlerts } from './program-event-join-status-alerts';

type P = {
  eventContentObject: PublicEventContentObject;
};

const PublicProgramEventContent = ({ eventContentObject }: P) => (
  <>
    <PublicProgramEventHeader eventContentObject={eventContentObject} />
    <TwoColumnLayout
      left={<ProgramEventJoinStatusAlerts eventContentObject={eventContentObject} />}
      right={<EventDetailCountdown startTime={eventContentObject.event.startTime} />}
    />
  </>
);

export default PublicProgramEventContent;
